import Model from './Model'

export default class Milestone extends Model {
  resource() {
    return 'admin/milestones'
  }
}
